import React from "react"
import {
  ClickAwayListener as MUIClickAwayListener,
  ClickAwayListenerProps as MUIClickAwayListenerProps,
} from "@mui/material"

export type ClickAwayListenerProps =
  | ({ new?: false } & MUIClickAwayListenerProps)
  | ({ new: true } & unknown)

export const ClickAwayListener = React.forwardRef<
  HTMLDivElement,
  ClickAwayListenerProps
>((props, ref) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  props.new ? null : <MUIClickAwayListener {...props} ref={ref} />,
)

ClickAwayListener.displayName = "ClickAwayListener"

export default ClickAwayListener
